// extracted by mini-css-extract-plugin
export default {"form":"reset-password_form__3iwN5","link":"reset-password_link__5Q7a-"};